export const GET_BANNERS = (state, data) => {
  state.banners = data
}
